import React, { Component } from 'react';
import { Radio } from '@3plearning/react-components';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import css from './index.scss';
import Checkbox from '../checkbox';
import { getTruncatedName } from '../../helpers/utils';

class SelectableListItem extends Component {
  constructor(props) {
    super(props);
    const { checked } = props;
    this.state = {
      checked,
      checkedNormal: this.props.checkedNormal,
      checkedEasier: this.props.checkedEasier
    };
    this.onRDBChange = this.onRDBChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({ checked: nextProps.checked });
    }

    this.setState({
      checkedNormal: this.props.checkedNormal,
      checkedEasier: this.props.checkedEasier
    });
  }

  onRDBChange(value) {
    if (value.indexOf('rdbNormal') >= 0) {
      this.props.onRadioselect(value.split('_')[1], true, false);
    }

    if (value.indexOf('rdbEasier') >= 0) {
      this.props.onRadioselect(value.split('_')[1], false, true);
    }
  }

  static getRadiobuttons(
    item,
    onChange,
    checkedNormal,
    checkedEasier,
    easierActivitiesCount,
    isChecked,
    i18n
  ) {
    const disabled = easierActivitiesCount === 0 || !isChecked;

    return (
      <>
        <span className={css.difficultyspan}>
          <Radio
            data-testid="core"
            name={`rdbDiff_${item.id}`}
            value={`rdbNormal_${item.id}`}
            selected={checkedNormal}
            disabled={disabled}
            onSelect={(value) => onChange(value)}
            label={i18n._(t('selectableListItem.core')`Core`)}
          />
        </span>
        <span className={css.difficultyspan}>
          <Radio
            data-testid="easier"
            name={`rdbDiff_${item.id}`}
            value={`rdbEasier_${item.id}`}
            selected={checkedEasier}
            disabled={disabled}
            onSelect={(value) => onChange(value)}
            label={i18n._(t('selectableListItem.easier')`Easier`)}
          />
        </span>
      </>
    );
  }
  onSelection = (cbState, cbId) => this.props.onChange(cbState, cbId);

  render() {
    const { id, name, i18n } = this.props;
    return (
      <div key={id}>
        <div className={css.info}>
          <div className={css.checkbox}>
            <Checkbox
              state={this.state.checked}
              checkboxHandler={(cbState, cbId) =>
                this.onSelection(cbState, cbId)
              }
              id={id.toString()}
            />
            <span title={name} className={css.description}>
              {getTruncatedName(name)}
            </span>
            {SelectableListItem.getRadiobuttons(
              this.props,
              this.onRDBChange,
              this.props.checkedNormal,
              this.props.checkedEasier,
              this.props.easierActivitiesCount,
              this.props.isChecked,
              i18n
            )}
          </div>
        </div>
      </div>
    );
  }
}

SelectableListItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  checked: PropTypes.string,
  easierActivitiesCount: PropTypes.number,
  onChange: PropTypes.func,
  checkedNormal: PropTypes.bool,
  checkedEasier: PropTypes.bool,
  onRadioselect: PropTypes.func,
  isChecked: PropTypes.bool,
  i18n: PropTypes.object
};

export default SelectableListItem;



// WEBPACK FOOTER //
// ./components/selectable-list-item/index.js